import { useQuery } from "@apollo/client";
import { clientNeoAuth } from "@neonumy/api-clients";
import { FormInstance } from "antd5";
import { LIST_GROUPS } from "queries/neoauth/users";
import { Dispatch, SetStateAction, useEffect, useRef } from "react";
import { onErrorGraphql } from "utils/onErrorGraphql";
import useCurrentUserGroups from "./useCurrentUserGroups";

interface GetListGroupsProps {
  form: FormInstance;
  setApplicationGroups: Dispatch<SetStateAction<UserGroupType[]>>;
}

export default function useGetListGroups({ form, setApplicationGroups }: GetListGroupsProps) {
  const groupsRef = useRef<UserGroupType[]>([]);
  const { groupDefaultOrder } = useCurrentUserGroups();

  const { data: groupsData, error: groupsError } = useQuery<
    ListGroupsQueryOutput,
    ListGroupsQueryInput
  >(LIST_GROUPS, {
    client: clientNeoAuth,
    fetchPolicy: "cache-first",
    variables: {
      filter: {
        userType_In: ["NEWRAI", "STANDARD", "CLIENT"],
      },
    },
  });

  useEffect(() => {
    if (groupsData) {
      groupsRef.current = groupsData.listGroups.map(item => ({
        label: item.name,
        value: item.id,
        userType: item.userType,
        slug: item.slug,
        isDisabled: groupDefaultOrder !== undefined && groupDefaultOrder >= item.order,
      }));
      if (form.getFieldValue("isNewraiUser")) {
        setApplicationGroups(groupsRef.current.filter(item => item.userType === "newrai"));
      } else {
        setApplicationGroups(groupsRef.current.filter(item => item.userType === "standard"));
      }
    }
  }, [groupsData]);

  useEffect(() => {
    if (groupsError) onErrorGraphql(groupsError);
  }, [groupsError]);

  return { groups: groupsRef.current, listGroups: groupsData?.listGroups ?? [] };
}
